var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle",
    clipPath: "url(#clip0_6686_21795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.83398C4.5949 1.83398 1.83398 4.5949 1.83398 8.00065C1.83398 11.4064 4.5949 14.1673 8.00065 14.1673C11.4064 14.1673 14.1673 11.4064 14.1673 8.00065C14.1673 4.5949 11.4064 1.83398 8.00065 1.83398ZM0.833984 8.00065C0.833984 4.04261 4.04261 0.833984 8.00065 0.833984C11.9587 0.833984 15.1673 4.04261 15.1673 8.00065C15.1673 11.9587 11.9587 15.1673 8.00065 15.1673C4.04261 15.1673 0.833984 11.9587 0.833984 8.00065Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89706 5.06941C6.66741 5.26426 6.50065 5.56133 6.50065 6.00066C6.50065 6.2768 6.27679 6.50066 6.00065 6.50066C5.72451 6.50066 5.50065 6.2768 5.50065 6.00066C5.50065 5.27331 5.79223 4.69538 6.25008 4.3069C6.69706 3.92764 7.27522 3.75065 7.83399 3.75065C8.39275 3.75065 8.97091 3.92764 9.41789 4.3069C9.87574 4.69538 10.1673 5.27331 10.1673 6.00066C10.1673 6.51124 10.0365 6.90031 9.82292 7.22071C9.64342 7.48996 9.41017 7.69812 9.22664 7.86189C9.20661 7.87977 9.18717 7.89712 9.16846 7.91396C8.96368 8.09825 8.80933 8.25018 8.6962 8.45005C8.58796 8.64126 8.50065 8.9084 8.50065 9.33395C8.50065 9.61009 8.27679 9.83395 8.00065 9.83395C7.72451 9.83395 7.50065 9.61009 7.50065 9.33395C7.50065 8.75949 7.62168 8.3183 7.82594 7.95744C8.02531 7.60524 8.28762 7.36134 8.49951 7.17065C8.51595 7.15585 8.532 7.14144 8.54766 7.12737C8.74781 6.94761 8.8857 6.82377 8.99088 6.66601C9.08977 6.51767 9.16732 6.32341 9.16732 6.00066C9.16732 5.56134 9.00056 5.26427 8.77091 5.06941C8.53039 4.86533 8.19188 4.75065 7.83398 4.75065C7.47608 4.75065 7.13757 4.86533 6.89706 5.06941Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3418 11.6283C8.54706 11.813 8.56369 12.1291 8.37896 12.3344L8.3723 12.3418C8.18757 12.5471 7.87142 12.5637 7.66617 12.379C7.46091 12.1942 7.44427 11.8781 7.629 11.6728L7.63567 11.6654C7.8204 11.4602 8.13655 11.4435 8.3418 11.6283Z",
    fill: "#9897A6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6686_21795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.ca9257898e64a46747ab2edf8545be76.svg";
export { ForwardRef as ReactComponent };